module.exports = __webpack_public_path__ + "static/media/yellowPic.150b55ce.jpg";